import { GetNonBenefitDiagnosisPriceSupportInvitationCodeQuery } from '@/types/bff/gql-schema';
import { useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery } from './non-benefit.gql.impl';

const parseGetNonBenefitDiagnosisPriceSupportInvitationCode = (
  data: GetNonBenefitDiagnosisPriceSupportInvitationCodeQuery
): string => {
  return data.getNonBenefitDiagnosisPriceSupportInvitationCode?.code ?? '';
};
const useGetNonBenefitDiagnosisPriceSupportInvitationCode = () => {
  const { data } = useGetNonBenefitDiagnosisPriceSupportInvitationCodeQuery(
    {},
    {
      select: parseGetNonBenefitDiagnosisPriceSupportInvitationCode,
    }
  );

  return {
    invitationCode: data,
  };
};

export default useGetNonBenefitDiagnosisPriceSupportInvitationCode;
